import { Helmet } from 'react-helmet-async';

import { Stack } from '@mui/material';

import { NotFoundError } from '@/widgets/error';

import { TITLE_META_TAG } from '@/shared/constants/titleMetaTag';

export const NotFoundPage = () => (
  <>
    <Helmet title={`Not found | ${TITLE_META_TAG}`} />
    <Stack height="100vh">
      <NotFoundError />
    </Stack>
  </>
);

export default NotFoundPage;
